import React from 'react';
import { FadeLoader } from 'react-spinners';

const Loader = () => (
  <div className='modal extraFilter js-open' style={{ zIndex: '2000' }} >
    <div className='modal-dialog modal-sm' role='document'>
      <FadeLoader color={'#F8A14A'} loading />
    </div>
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js